import { Fragment, type ReactNode } from "react";
import { partesDoTexto } from "@/core/ajuda/licoes";

/**
 * Peças visuais compartilhadas pelas telas da Ajuda do Elos. Só tokens do
 * design system; alvos de toque de 48 px para quem tem pouca prática com o
 * celular.
 */

export const BTN_BASE =
  "inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-xl px-5 text-base font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto";
export const BTN_PRIMARIO = `${BTN_BASE} bg-primary text-on-primary hover:bg-primary-hover`;
export const BTN_SECUNDARIO = `${BTN_BASE} border border-border bg-surface text-text hover:bg-surface-2`;
export const BTN_TEXTO = `${BTN_BASE} text-primary hover:bg-surface-2 dark:text-text dark:underline dark:underline-offset-4`;

export const PAGINA_AJUDA = "mx-auto w-full max-w-xl px-4 pb-8 pt-6 sm:px-6 sm:pt-10";

/** Parágrafo com `**negrito**` e quebras de linha; o React escapa o texto. */
export function TextoAjuda({ texto, className = "" }: { texto: string; className?: string }) {
  return (
    <p className={`whitespace-pre-line text-lg leading-relaxed text-text ${className}`}>
      {partesDoTexto(texto).map((p, i) => (
        <Fragment key={i}>{p.negrito ? <strong>{p.texto}</strong> : p.texto}</Fragment>
      ))}
    </p>
  );
}

/** Barra de progresso discreta: o texto diz tudo, a barra só reforça. */
export function BarraProgresso({ rotulo, percentual }: { rotulo: string; percentual: number }) {
  return (
    <div className="mb-5 flex items-center gap-3 text-sm font-semibold text-muted">
      <span className="shrink-0">{rotulo}</span>
      <span aria-hidden="true" className="h-1.5 flex-1 overflow-hidden rounded-full bg-surface-2">
        <span
          className="block h-full rounded-full bg-primary"
          style={{ width: `${Math.min(Math.max(percentual, 0), 100)}%` }}
        />
      </span>
    </div>
  );
}

export function Aviso({ icone, children }: { icone: ReactNode; children: ReactNode }) {
  return (
    <div className="mt-4 flex items-start gap-3 rounded-xl border border-border bg-surface-2 p-3.5 text-base text-text">
      <span className="mt-0.5 shrink-0 text-primary">{icone}</span>
      <span className="min-w-0 flex-1">{children}</span>
    </div>
  );
}
